const getComponents = (mode) => ({
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        scrollbarWidth: 'thin',
        scrollbarColor: mode === 'dark' ? '#334155 #0a0f1a' : '#cbd5e1 #f8fafc',
      },
    },
  },
  MuiCard: {
    defaultProps: { variant: 'outlined' },
    styleOverrides: {
      root: {
        borderRadius: 12,
        backgroundImage: 'none',
        ...(mode === 'dark' && { boxShadow: 'none' }),
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: { borderRadius: 8, textTransform: 'none', fontWeight: 500 },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: { borderRadius: 6 },
    },
  },
  MuiTextField: {
    defaultProps: { variant: 'outlined', size: 'small' },
  },
  MuiTab: {
    styleOverrides: {
      root: { textTransform: 'none', fontWeight: 500, minHeight: 44 },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: { borderRadius: 6, fontSize: '0.75rem' },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: { borderRadius: 8 },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: { backgroundImage: 'none' },
    },
  },
});

export default getComponents;
